export default {
  computed: {
    isChromeDesktop: function () {
      let ua = window.navigator.userAgent
      return /Chrome/i.test(ua) && !/Android/i.test(ua)
    },
  },
}
